import React from 'react';
import { connect } from "react-redux";

import isEqual from 'lodash/isEqual'
import classNames from 'classnames';

import Snackbar from '@material-ui/core/Snackbar';
import * as actions from "./../../actions";
import CloseIcon from '@material-ui/icons/Close';

import IconButton from '@material-ui/core/IconButton';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';

import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import PropTypes from 'prop-types';

import { withStyles} from '@material-ui/core/styles';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const styles1 = theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    paddingRight: theme.spacing.unit,
    fontSize: 25,
  },
  message: {
    height:"100%",
    display: 'flex',
    flexDirection:"row",
    alignItems: 'flex-start',
  },
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          <div style={{
            height: "100%",
            display: 'flex',
            flexDirection:"column",
            justifyContent:"center",
            placeContent: 'center',}}>
            {message.title && <div>{message.title}</div>}
            {message.body && (<div>
              {message.body} {message.link && <a href="#" onClick={()=>window.location.replace(message.link.path)}>{message.link.title}</a>}
            </div>)}
          </div>


        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>,
      ]}
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
};

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);


const styles = theme => ({

   icon: {
     fontSize: 20,
   },
   iconVariant: {
     opacity: 0.9,
     marginRight: theme.spacing.unit,
   },
   message: {
     display: 'flex',
     alignItems: 'center',
   },


})

class DisplayedMessage extends React.Component {
  state = {
    webpageInfoData: this.props.webpageInfoData,

  };

  componentDidUpdate(prevProps){

    if(!isEqual(prevProps.webpageInfoData, this.props.webpageInfoData)){

        this.setState({webpageInfoData: this.props.webpageInfoData})
    }
  }


  handleClose = () => {
    this.props.closeWebpageDisplayedInfo()
  };

  render() {
    const {classes} = this.props
    const { webpageInfoData } = this.state;

    return(
      <div >
        <Snackbar
          anchorOrigin={{vertical: "top",horizontal: "right" }}
          open={webpageInfoData !== null}
          autoHideDuration={10000}
          onClose={this.handleClose}
          style={{zIndex:5000}}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}

          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.handleClose}
            >
              <CloseIcon className={classes.icon} />
            </IconButton>,
          ]}
        >
          <MySnackbarContentWrapper
            onClose={this.handleClose}
            variant={webpageInfoData && webpageInfoData.type ? webpageInfoData.type : "info"}
            message={webpageInfoData ? webpageInfoData : {}}

          />
        </Snackbar>
      </div>
    )

  }
}


DisplayedMessage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = ({ webpageInfoData }) => {
  return {
    webpageInfoData
  };
};

export default connect(mapStateToProps, actions)( withStyles(styles, { withTheme: true })(DisplayedMessage))



// WEBPACK FOOTER //
// ./src/components/main/DisplayedMessage.js